/**
 * "Press anywhere" listeners for closing dropdowns, menus and popovers on an
 * outside click — the replacement for document.addEventListener("mousedown").
 *
 * mousedown on document is not reliable on Apple devices, which is where
 * "clicking outside doesn't close the dropdown" was reported:
 *
 *  - Safari does not give a tap the mousedown a click gets. On touch (iPad, a
 *    touch-enabled Mac setup) it synthesises mouse events late, and on a
 *    non-interactive target — a member row, empty page space — it may not
 *    deliver them to document at all, so the menu simply stays open.
 *    pointerdown is one event for mouse, trackpad, touch and pen (Safari 13+).
 *  - Capture phase, so a stopPropagation() anywhere between the target and
 *    document cannot swallow the press and leave the menu stuck open.
 *
 * Old browsers without PointerEvent fall back to mousedown + touchstart.
 * Same approach CourseSearch.jsx settled on. Call remove with the SAME handler.
 */
const OPTS = { capture: true };

const events = () =>
  typeof window !== "undefined" && window.PointerEvent ? ["pointerdown"] : ["mousedown", "touchstart"];

export function addOutsidePress(handler) {
  events().forEach((name) => document.addEventListener(name, handler, OPTS));
}

export function removeOutsidePress(handler) {
  events().forEach((name) => document.removeEventListener(name, handler, OPTS));
}
